var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 515,
    viewBox: "0 0 500 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90302 319.339L0 326.734L129.563 342.845C148.385 350.337 168.018 355.688 188.256 358.959C195.053 293.092 265.069 241.134 350.233 241.134C384.742 241.134 416.745 249.686 443.09 264.217C459.557 239.386 468.914 211.238 468.914 181.401C468.914 81.379 364.334 0 235.777 0C107.219 0 2.62802 81.379 2.62802 181.401C2.62802 217.311 16.1 251.895 41.615 281.732L41.409 281.889L43.902 284.531C41.033 290.352 24.166 306.638 8.90302 319.339ZM80.547 100.914H384.463V117.421H80.547V100.914ZM80.547 162.146H384.463V178.656H80.547V162.146ZM80.547 223.384H241.453V239.894H80.547V223.384Z",
    fill: "#3E0079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.001 369.486C201.001 432.906 267.961 484.497 350.233 484.497C368.425 484.497 386.316 481.931 403.406 476.886L407.037 475.818L448.881 514.487V455.637L451.665 453.64C482.034 431.877 499.452 401.199 499.452 369.486C499.452 306.073 432.492 254.476 350.233 254.476C267.961 254.476 201.001 306.073 201.001 369.486Z",
    fill: "#8A58CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.463 100.914H80.5469V117.421H384.463V100.914Z",
    fill: "#8A58CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M384.463 162.146H80.5469V178.656H384.463V162.146Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.453 223.384H80.5469V239.894H241.453V223.384Z",
    fill: "#8A58CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.27ed44e34fce2932bbc48e7e1a953aba.svg";
export { ForwardRef as ReactComponent };